import { render, staticRenderFns } from "./similarity-groups.vue?vue&type=template&id=059b1422&scoped=true"
import script from "./similarity-groups.vue?vue&type=script&lang=js"
export * from "./similarity-groups.vue?vue&type=script&lang=js"
import style0 from "./similarity-groups.vue?vue&type=style&index=0&id=059b1422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b1422",
  null
  
)

export default component.exports